
/**
 * Fetches settings for a specific establishment.
 * @param {string} API_BASE 
 * @param {string} token 
 * @param {string} code_etablissement 
 */
async function getSettings(API_BASE, token, code_etablissement) {
    const headers = {
        "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE}/settings?code_etablissement=${code_etablissement}`, {
        method: "GET",
        headers,
    });
    //console.log(response);
    if (!response.ok) {
        throw new Error("Erreur lors de la récupération des paramètres: " + (await response.text()));
    }

    return await response.json();
}

export default getSettings;
